// extracted by mini-css-extract-plugin
export default {"needMapping":"LeonA-List_needMapping__zGmWI","noMapping":"LeonA-List_noMapping__6-QDQ"};